// This file is auto-generated by @skynet/data-helpers/scripts/generate-rtk-exports.mjs
// Do not edit manually.

import { hookExports } from './bug-reports-api';

export const useCreateBugReport: typeof hookExports.useCreateBugReport =
  hookExports.useCreateBugReport;
